import {
  IGetPostingsResult,
  IPostingApiModel,
  IPostingEntity,
  IPostingsApiResponse,
} from '../types';

const toPostingEntity = (
  model: IPostingApiModel,
): IPostingEntity => {
  return {
    id: model.id,
    officeId: model.officeId,
    officeName: model.officeName,
    title: model.title,
  };
};

const toGetPostingsResult = (
  response: IPostingsApiResponse,
): IGetPostingsResult => {
  return {
    data: response.data.map(toPostingEntity),
    pagination: {
      page: response.page,
      limit: response.pageSize,
      total: response.total,
    },
  };
};

export const postingAdapters = {
  toGetPostingsResult,
  toPostingEntity,
};
